import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import * as echarts from "echarts";
import { isEmpty } from "@/utils/shared";
export default {
  name: "FollowUp",
  props: ["source", "id"],
  watch: {
    source: function source() {
      this.init();
    },
    id: function id() {
      this.echart && this.echart.resize();
    }
  },
  data: function data() {
    return {
      echart: null
    };
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      if (isEmpty(this.echart)) {
        this.echart = echarts.init(document.getElementById("followUp"));
      }
      var echart = this.echart;
      var color = "#F9FAFA";
      echart.setOption({
        legend: {
          orient: "vertical",
          top: "5%",
          right: "6%",
          data: ["已处理", "未处理"],
          itemHeight: this.size(14),
          itemWidth: this.size(14),
          itemGap: parseInt(this.size(16)),
          textStyle: {
            fontSize: this.size(12),
            color: color,
            padding: [0, 0, 0, this.size(4)]
          }
        },
        grid: {
          top: "15%",
          bottom: "14%",
          right: "26%"
        },
        xAxis: {
          type: "category",
          data: ["电话随访", "问卷随访", "短信随访"],
          axisLabel: {
            color: color,
            fontSize: this.size(12)
          }
        },
        yAxis: {
          name: "单位：次",
          type: "value",
          nameTextStyle: {
            color: "#fff",
            opacity: 0.5,
            fontSize: this.size(12)
          },
          axisLabel: {
            color: color,
            fontSize: this.size(12)
          }
        },
        series: [{
          name: "已处理",
          type: "bar",
          itemStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: "#1272FF" // 0% 处的颜色
              }, {
                offset: 1,
                color: "#29ABFF" // 100% 处的颜色
              }]
            },

            borderRadius: [6, 6, 0, 0]
          },
          label: {
            show: true,
            position: "top",
            color: "#27A8FF"
          },
          emphasis: {
            disabled: true
          },
          data: ["alreadyPhone", "alreadyWj", "alreadySms"].map(function (key) {
            return _this.source[key] || 0;
          }),
          barWidth: "20%"
        }, {
          name: "未处理",
          type: "bar",
          itemStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: "#9FFFFF" // 0% 处的颜色
              }, {
                offset: 1,
                color: "#66FFFF " // 100% 处的颜色
              }]
            },

            borderRadius: [6, 6, 0, 0]
          },
          label: {
            show: true,
            position: "top",
            color: "#2DFFDB"
          },
          emphasis: {
            disabled: true
          },
          data: ["waitPhone", "waitWj", "waitSms"].map(function (key) {
            return _this.source[key] || 0;
          }),
          barWidth: "20%"
        }]
      });
    },
    size: function size(sz) {
      return sz / 14 * document.documentElement.style.fontSize.slice(0, -2);
    }
  }
};